import { render, staticRenderFns } from "./BaseInputFileModal.vue?vue&type=template&id=1c16e515&scoped=true&"
import script from "./BaseInputFileModal.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileModal.vue?vue&type=style&index=0&id=1c16e515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16e515",
  null
  
)

export default component.exports